import { render, staticRenderFns } from "./PhotoBookInteriorPreview.vue?vue&type=template&id=6373a550&scoped=true"
import script from "./PhotoBookInteriorPreview.vue?vue&type=script&lang=js"
export * from "./PhotoBookInteriorPreview.vue?vue&type=script&lang=js"
import style0 from "./PhotoBookInteriorPreview.vue?vue&type=style&index=0&id=6373a550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6373a550",
  null
  
)

export default component.exports